import React, { useContext } from "react";
import { Container, Row } from "react-bootstrap";

import utils from "utils";
import { UmbracoContext } from "components/Umbraco/UmbracoContext";

const { UmbracoUtills } = utils;

export default function Footer() {
  const resource = useContext(UmbracoContext).resource.properties;

  return (
    <div className="wrapper mt-5">
      <Container>
        <Row>
          <div className="footer mt-5">
            {UmbracoUtills.getParsedHtmlValueByKey(resource, "footer")}
          </div>
        </Row>
      </Container>
    </div>
  );
}
